/**
 * possible statuses
 *
 * https://bitbucket.hotterpads.com/projects/RP/repos/trulia/browse/leasing/src/main/java/com/hotpads/leasing/model/enums/connectedzrm/ZrmStatusText.java
 */

const LEASE_STATUS = {
    ACTIVE: 'active',
    ACTIVE_EXPIRING_SOON: 'active expiring soon',
    AWAITING_YOUR_SIGNATURE: 'awaiting your signature',
    COMPLETE_DRAFT: 'complete draft',
    EXPIRED: 'expired',
    INCOMPLETE_DRAFT: 'incomplete draft',
    SIGNING_CANCELED: 'signing canceled',
    SIGNING_CANCELLED: 'signing cancelled',
    SIGNING_COMPLETE: 'signing complete',
    SIGNING_IN_PROGRESS: 'signing in progress',
    SIGNING_OFFLINE: 'signing offline',
};

export {
    LEASE_STATUS,
};
